import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LoginEnter',
    component: () => import('../views/Main/LoginEnter.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  //----------------------------------------------------------------------- 
  {
    path: '/MenuWebPlusCustomer',
    name: 'MenuWebPlusCustomer',
    component: () => import('../views/Main/MenuWebPlusCustomer.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/CustomerContractList',
    name: 'CustomerContractList',
    component: () => import('../views/Main/CustomerContractList.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/CustomerContractDetail',
    name: 'CustomerContractDetail',
    component: () => import('../views/Main/CustomerContractDetail.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/CreditAgreementDownload',
    name: 'CreditAgreementDownload',
    component: () => import('../views/Main/CreditAgreementDownload.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/PaymentDetailsDownload',
    name: 'PaymentDetailsDownload',
    component: () => import('../views/Main/PaymentDetailsDownload.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/EarlyPaymentReference',
    name: 'EarlyPaymentReference',
    component: () => import('../views/Main/EarlyPaymentReference.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },  
  {
    path: '/QASearch',
    name: 'QASearch',
    component: () => import('../views/Main/QASearch.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/QASearch2',
    name: 'QASearch2',
    component: () => import('../views/Main/QASearch2.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/QADetail',
    name: 'QADetail',
    component: () => import('../views/Main/QADetail.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/CustomerDetail',
    name: 'CustomerDetail',
    component: () => import('../views/Main/CustomerDetail.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/PasswordChange',
    name: 'PasswordChange',
    component: () => import('../views/Main/PasswordChange.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ' }
  },
  {
    path: '/PasswordResetRequest',
    name: 'PasswordResetRequest',
    component: () => import('../views/Main/PasswordResetRequest.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/PasswordReset',
    name: 'PasswordReset',
    component: () => import('../views/Main/PasswordReset.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション'  }
  },
  {
    path: '/AccountChange',
    name: 'AccountChange',
    component: () => import('../views/Main/AccountChange.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  //★START ADD 20231127 wxl
  {
    path: '/MypageAgreement',
    name: 'MypageAgreement',
    component: () => import('../views/Main/MypageAgreement.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/MemberCustomer',
    name: 'MemberCustomer',
    component: () => import('../views/Main/MemberCustomer.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/MemberWorks',
    name: 'MemberWorks',
    component: () => import('../views/Main/MemberWorks.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/MemberContact',
    name: 'MemberContact',
    component: () => import('../views/Main/MemberContact.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/GuarantorMemberContact',
    name: 'GuarantorMemberContact',
    component: () => import('../views/Main/GuarantorMemberContact.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/Document/:procType',
    name: 'Document',
    component: () => import('../views/Main/DocumentManage.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/AccountRegister',
    name: 'AccountRegister',
    component: () => import('../views/Main/AccountRegister.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/AgreementKojin',
    name: 'AgreementKojin',
    component: () => import('../views/Main/AgreementKojin.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/AgreementKapan',
    name: 'AgreementKapan',
    component: () => import('../views/Main/AgreementKapan.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/CorporationInf',
    name: 'CorporationInf',
    component: () => import('../views/Main/CorporationInf.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/MemberGuarantor/:procType',
    name: 'MemberGuarantor',
    component: () => import('../views/Main/MemberGuarantor.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/SignatureInput',
    name: 'SignatureInput',
    component: () => import('../views/Main/SignatureInput.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/FinalScreen',
    name: 'FinalScreen',
    component: () => import('../views/Main/FinalScreen.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  {
    path: '/SendFinalScreen',
    name: 'SendFinalScreen',
    component: () => import('../views/Main/SendFinalScreen.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  },
  //★END ADD 20231127 wxl
  {
    path: '/Reception/PaymentAccountRegistrationComplete',
    name: 'PaymentAccountRegistrationComplete',
    component: () => import('../views/Reception/PaymentAccountRegistrationComplete.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  } , 
  {
    path: '/Reception/PaymentAccountRegistrationError',
    name: 'PaymentAccountRegistrationError',
    component: () => import('../views/Reception/PaymentAccountRegistrationComplete.vue'),
    meta: { title: 'Ｄ－スクエア＋ お客様Mｙページ', desc: 'ディスクリプション' }
  } , 
]

const router = new VueRouter({
  routes
})

router.beforeEach( function (to, from, next ) {
  //遷移元を保管  
  router['referrer'] = from;

  //ログインチェック
  var isAuthenticated = false;
  var wData = sessionStorage.getItem('logoninfo');
  if ( wData != null  )
  {
    isAuthenticated = true;
    var wlogininfo = JSON.parse(wData);
    var wSession_Id = wlogininfo.session_Id;  
    if ( wSession_Id != null )
    {
      isAuthenticated = true;
    }
  }

  if ( !isAuthenticated ) {
    if (to.name == 'PasswordResetRequest') {
      //メール再設定リクエスト画面へ飛ばす
      next();
    } 
    else if (to.name == 'PasswordReset') {
      //メール再設定画面へ飛ばす
      next();
    }
    else if ( to.name !== 'LoginEnter' 
      && to.name !== 'AccountChange'
      && to.name !== 'PaymentAccountRegistrationComplete'
      && to.name !== 'PaymentAccountRegistrationError'){
      //未ログインはログイン画面に飛ばす
      next({ name: 'LoginEnter' });
    }
  }
  next();
})

export default router
